const ASSETS_BASE =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_5293e26b-027a-4970-aec8-57e644caf42d/artifacts";
const NEW_BASE =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_luxury-stone-craft-2/artifacts";

export const ASSETS = {
  logo: `${ASSETS_BASE}/k01m5ujs_BC66FA85-893F-4F3B-BBB7-0A676E125042.png`,
  banner: `${ASSETS_BASE}/6t8ugrzs_3F2CD0EB-6C54-4383-AE50-1292D5BA6F4C.png`,
  gifts: `${ASSETS_BASE}/zkkbyjsu_95AB2D39-4A19-4FFC-A930-8CDB40D81CA8.png`,
  office: `${ASSETS_BASE}/vup59oct_AA403581-7874-4F5E-BCD0-5A9B77FAA814.png`,
  wallart: `${ASSETS_BASE}/blz996uj_D4791267-F497-41E9-9177-5E9BE302B435.png`,
  hanuman: `${NEW_BASE}/9ad56s7d_A19308F1-372C-43C3-BD24-262D1934AEEC.png`,
  muralHorse: `${NEW_BASE}/kwt0oujb_4DDCAC2D-85D0-4579-99CC-879AE04AA1D2.png`,
  muralLake: `${NEW_BASE}/v13m6mzo_CA7004F9-BD51-4F6E-AD32-7A0219496B69.png`,
  tileFanMarble: `${NEW_BASE}/w78golpv_B5433D18-C208-4C7D-9168-E6C0642216A5.png`,
  tileXoMarble: `${NEW_BASE}/qdw9kj92_1B944B49-2179-43F9-A934-E84D68D30AF7.png`,
  tileFanWhite: `${NEW_BASE}/7injknfq_3B83BEF3-9153-485E-A2F5-B6AD4B144B6E.png`,
  tileMonstera: `${NEW_BASE}/q3m4b051_84574AE3-1EAF-4B89-BE21-0346D4542631.png`,
  tileXoSand: `${NEW_BASE}/vf4vvg86_ACDECBA8-6F26-4882-ABB1-68F33D82F223.png`,
  shivaMural: `${NEW_BASE}/fr41ezn3_5375C04C-F58C-4324-A73D-243B5070A714.png`,
  treeReception: `${NEW_BASE}/nk6i4yli_13C5777B-DA01-42EB-8A5A-EAF443A6BE19.png`,
  confRoom: `${NEW_BASE}/wi07sc3n_5C24CD2E-CE4A-400E-999D-73BCDF871CB8.png`,
  headSculpture: `${NEW_BASE}/6eqktlnh_96C212CE-6566-422B-8459-AD2EAC783650.png`,
  graniteGanesha: `${NEW_BASE}/0qhybu3t_4A121B2A-FD82-4439-A87E-D6C6358069B9.png`,
  shivParivar: `${NEW_BASE}/9k7vp94u_6267BA14-664E-4EE9-9C9A-431DD494794D.png`,
  krishnaRelief: `${NEW_BASE}/acz5a1f7_6DA0131A-3E24-4FF3-985E-1C1F12747B1B.png`,
  artisanBlue: `${NEW_BASE}/82qca9yp_IMG_1762.webp`,
  artisanGreen: `${NEW_BASE}/dbsho80x_IMG_1763.jpeg`,
  floorBoard: `${NEW_BASE}/3shcyemp_CFF5C350-9242-40E4-B103-CDA51794E673.jpeg`,
  floorBoard2: `${NEW_BASE}/exdomm7i_2CFBE36B-5BF3-42AC-857A-4A97EBC312F4.jpeg`,
  shrinathjiCows: `${NEW_BASE}/kn34xukp_0384654F-213A-4AD6-A0B8-54E68EDD62D6.png`,
  elephantPanel: `${NEW_BASE}/1cvrxmgr_19AB8D0A-563B-4093-A8AA-03D07D948D39.png`,
  horsePanel: `${NEW_BASE}/1jhxqo18_DD05DEC4-2622-49EF-A38D-AC72AB03220D.png`,
  artisanPainting: `${NEW_BASE}/smbc2xs5_f58c4801-ae9c-4d13-8d4b-8eb961f7c5fe.webp`,
  panelLineup: `${NEW_BASE}/qkxh3cah_FCFE3B38-D6F0-4B4C-B636-23FB52D32C21.png`,
  kitchenIsland: `${NEW_BASE}/a7grks6v_E7020935-4484-40CE-AA7B-C32B55FD7008.png`,
  kitchenVanitySuite: `${NEW_BASE}/j1fszqkf_6B32EB1A-EA22-4721-9043-47B8C8695D76.png`,
  clientVisit: `${NEW_BASE}/hvfmg95b_5bc5a409-8326-4e73-88fd-0d6ccab531e5.jpeg`,
  clientVisit2: `${NEW_BASE}/fzrph7z7_03c0c926-26b6-42b4-b421-e32b13f17503.jpeg`,
  cncMachine: `${NEW_BASE}/ckgqe92j_IMG_1786.jpeg`,
  bridgeSaw: `${NEW_BASE}/5xid2y40_IMG_1787.jpeg`,
  marbleBust: `${NEW_BASE}/hl8eu86e_DBC161C2-03A4-4959-A111-73DCA509896D.png`,
  tileXoWhite: `${NEW_BASE}/fin8pyqy_1B944B49-2179-43F9-A934-E84D68D30AF7.jpeg`,
  ganeshaLine: `${NEW_BASE}/ckiz35n5_948D0A50-3558-4CBB-8434-F30CA115CD63.png`,
  elephantFramed: `${NEW_BASE}/0633124110b09476_ED0C6200-944A-4CC4-80BF-01ECB197E0B3.png`,
  horseFramed: `${NEW_BASE}/c28d30c82c77d093_D9AC42AE-EC63-4A29-94C8-3C94A8B0662A.png`,
  balajiPanel: `${NEW_BASE}/4411e32d20ab49ca_B2DDE8EF-923B-45C3-B880-DB429216A479.png`,
  krishnaFramed: `${NEW_BASE}/9aebe30a560c86a9_23313BBD-7C8D-468F-A15A-2B20E37B9425.png`,
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1758448755981-954afbf60ff7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ6Mzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMG1hcmJsZSUyMHJlY2VwdGlvbiUyMGRlc2slMjBzdG9uZSUyMHdhbGx8ZW58MHx8fHwxNzkwNjY3OTA0fDA&ixlib=rb-4.1.0&q=85",
  artisan:
    "https://images.unsplash.com/photo-1703258574645-060c9a9cf918?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxzdG9uZSUyMHNjdWxwdHVyZSUyMGFydGlzYW4lMjBjYXJ2aW5nJTIwY2hpc2VsfGVufDB8fHx8MTc5MDY2Nzg5Nnww&ixlib=rb-4.1.0&q=85",
  heritage:
    "https://images.unsplash.com/photo-1591264247469-d072a1018915?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHx1ZGFpcHVyJTIwcGFsYWNlJTIwYXJjaGl0ZWN0dXJhbCUyMG1hcmJsZSUyMGphYWxpJTIwd2luZG93fGVufDB8fHx8MTc5MDY2NzkwNHww&ixlib=rb-4.1.0&q=85",
  jaali: "https://images.unsplash.com/photo-1777603371625-fe9aa715dc39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtYXJibGUlMjB3YWxsJTIwYXJjaGl0ZWN0dXJhbCUyMHN0b25lJTIwY2FydmluZ3xlbnwwfHx8fDE3OTA2Njc4OTZ8MA&ixlib=rb-4.1.0&q=85",
  carving:
    "https://images.unsplash.com/photo-1638052473415-7c31daed7373?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtYXJibGUlMjB3YWxsJTIwYXJjaGl0ZWN0dXJhbCUyMHN0b25lJTIwY2FydmluZ3xlbnwwfHx8fDE3OTA2Njc4OTZ8MA&ixlib=rb-4.1.0&q=85",
  ganesha:
    "https://images.unsplash.com/photo-1616908841648-a4bc4322d64e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxoaW5kdSUyMGdhbmVzaGElMjBzdG9uZSUyMHNjdWxwdHVyZXxlbnwwfHx8fDE3ODMzNjU1NjJ8MA&ixlib=rb-4.1.0&q=85",
  flooring:
    "https://images.unsplash.com/photo-1671554203284-b16198df2c50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtYXJibGUlMjB3YWxsJTIwYXJjaGl0ZWN0dXJhbCUyMHN0b25lJTIwY2FydmluZ3xlbnwwfHx8fDE3OTA2Njc4OTZ8MA&ixlib=rb-4.1.0&q=85",
  furniture:
    "https://images.unsplash.com/photo-1601507777683-907b4ea76465?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxzdG9uZSUyMHNjdWxwdHVyZSUyMGFydGlzYW4lMjBjYXJ2aW5nJTIwY2hpc2VsfGVufDB8fHx8MTc5MDY2Nzg5Nnww&ixlib=rb-4.1.0&q=85",
  custom:
    "https://images.unsplash.com/photo-1742497359516-9f3ee2fce262?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxzdG9uZSUyMHNjdWxwdHVyZSUyMGFydGlzYW4lMjBjYXJ2aW5nJTIwY2hpc2VsfGVufDB8fHx8MTc5MDY2Nzg5Nnww&ixlib=rb-4.1.0&q=85",
  artisanIndian:
    "https://images.unsplash.com/photo-1749370721285-ca1ffdffddec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MTJ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBhcnRpc2FuJTIwc3RvbmUlMjBjYXJ2aW5nJTIwY3JhZnRzbWFufGVufDB8fHx8MTc5MDY3MDU3NXww&ixlib=rb-4.1.0&q=85",
  artisanDetail:
    "https://images.unsplash.com/photo-1712210332599-0cb76e647e43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MTJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBhcnRpc2FuJTIwc3RvbmUlMjBjYXJ2aW5nJTIwY3JhZnRzbWFufGVufDB8fHx8MTc5MDY3MDU3NXww&ixlib=rb-4.1.0&q=85",
  kitchen:
    "https://images.unsplash.com/photo-1610276099118-c929abaaa80a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA6OTV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtYXJibGUlMjBraXRjaGVuJTIwY291bnRlcnRvcCUyMGludGVyaW9yfGVufDB8fHx8MTc5MDY4MDEzMHww&ixlib=rb-4.1.0&q=85",
  cnc: "https://images.unsplash.com/photo-1580920461922-ee625ecbfc27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzN8MHwxfHNlYXJjaHwzfHxjbmMlMjByb3V0ZXIlMjBtYWNoaW5lJTIwd29ya3Nob3B8ZW58MHx8fHwxNzkwNjcwNTg1fDA&ixlib=rb-4.1.0&q=85",
  workshopTeam:
    "https://images.unsplash.com/photo-1712210332519-f90f3d37ceb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3b3JrZXJzJTIwc3RvbmUlMjB3b3Jrc2hvcCUyMHNjdWxwdG9yfGVufDB8fHx8MTc5MDY3MDU4Mnww&ixlib=rb-4.1.0&q=85",
};

export const WA_NUMBER = "919602291176";
export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;
export const WA_DEFAULT_MSG =
  "Hello ShilpStones Creations, I am interested in your architectural stone carving services.";

export const CONTACT = {
  phones: [
    { label: "+91 96022 91176", tel: "+919602291176", wa: "919602291176" },
    { label: "+91 94141 57986", tel: "+919414157986", wa: "919414157986" },
  ],
  addresses: [
    { label: "Studio & Store", value: "Near Kia Service, Main Road, Sukher, Udaipur — 313001" },
    { label: "Plant", value: "Bhilo ka Bedala, Udaipur, Rajasthan — 313001" },
  ],
  email: "Shilpstonescreations@gmail.com",
};

export const CATEGORIES = [
  "All",
  "Residential",
  "Hospitality",
  "Corporate",
  "Religious",
  "Architectural",
  "Art & Sculpture",
];

export const EXPERTISE = [
  {
    slug: "wall-art",
    title: "Interior & Exterior Wall Art",
    desc: "Custom carved panels, botanical reliefs, heritage motifs, geometric compositions and statement feature walls.",
    image: ASSETS.shrinathjiCows,
    points: ["Double-height carved murals", "Backlit relief panels", "Botanical & heritage motifs"],
  },
  {
    slug: "sculptures",
    title: "Stone Art & Sculptures",
    desc: "Relief sculptures, devotional artwork, cultural themes, figurative carving and bespoke stone masterpieces.",
    image: ASSETS.krishnaFramed,
    points: ["Devotional & cultural themes", "Figurative carving", "Bespoke masterpieces"],
  },
  {
    slug: "resort-villa",
    title: "Resort & Villa Projects",
    desc: "Luxury stone environments for villas, resorts, hotels and hospitality spaces.",
    image: "/brochure/crops/hotel-lobby.jpg",
    points: ["Arrival & lobby experiences", "Courtyards & water features", "End-to-end stone packages"],
  },
  {
    slug: "reception-office",
    title: "Reception & Office Spaces",
    desc: "Reception desks, executive walls, corporate interiors, office tables and conference environments.",
    image: ASSETS.confRoom,
    points: ["Brand walls & monograms", "Executive stone desks", "Conference environments"],
  },
  {
    slug: "architectural",
    title: "Architectural Elements",
    desc: "Jaalis, screens, arches, niches, columns, borders and custom architectural detailing.",
    image: ASSETS.panelLineup,
    points: ["Perforated jaali screens", "Arches, niches & columns", "Custom architectural detailing"],
  },
  {
    slug: "flooring-cladding",
    title: "Flooring & Cladding",
    desc: "Premium natural stone flooring, wall cladding, borders, patterns and inlay concepts.",
    image: ASSETS.floorBoard2,
    points: ["Large-format stone flooring", "Exterior & interior cladding", "Inlay borders & patterns"],
  },
  {
    slug: "kitchen-vanity",
    title: "Kitchen & Vanity",
    desc: "Kitchen platforms, backsplashes, vanity tops, bathroom surrounds and functional stone surfaces.",
    image: ASSETS.kitchenIsland,
    points: ["Stone kitchen platforms", "Vanity tops & surrounds", "Seamless backsplashes"],
  },
  {
    slug: "stone-furniture",
    title: "Stone Furniture",
    desc: "Office tables, conference tables, consoles, dining tables and custom stone furniture.",
    image: "/brochure/crops/office-conf.jpg",
    points: ["Dining & conference tables", "Consoles & side tables", "Custom heirloom pieces"],
  },
  {
    slug: "gifting",
    title: "Gifting & Corporate Gifting",
    desc: "Awards, commemorative pieces, desk accessories, custom gifts and premium stone objects.",
    image: ASSETS.gifts,
    points: ["Corporate awards & trophies", "Festive & wedding gifting", "Personalised stone objects"],
  },
  {
    slug: "custom",
    title: "CNC Carving & Custom Creations",
    desc: "Precision CNC carving and unique stone concepts developed around individual requirements.",
    image: ASSETS.cncMachine,
    points: ["Precision CNC carving", "One-of-one commissions", "Concept-to-installation"],
  },
];

export const MATERIALS = [
  { name: "White Marble", note: "Intricate CNC detailing", image: ASSETS.tileFanMarble },
  { name: "Natural Sandstone", note: "CNC + sand blast finish", image: ASSETS.tileXoSand },
  { name: "Black Granite", note: "Ganesha line-art panel", image: ASSETS.ganeshaLine },
  { name: "Botanical Relief", note: "Hand-finished textures", image: ASSETS.tileMonstera },
];

export const FALLBACK_PROJECTS = [
  {
    id: "p2",
    name: "Lakeside Resort Lobby",
    location: "Lake Pichola, Udaipur",
    category: "Hospitality",
    type: "Reception wall & lobby cladding",
    materials: "Backlit onyx, beige marble, brass inlay",
    services: "Material selection, wall cladding, reception desk, lighting detail",
    image: "/brochure/crops/hotel-lobby.jpg",
    description: "A glowing onyx arrival experience for a boutique lakeside resort.",
    featured: true,
  },
  {
    id: "p12",
    name: "Shiv Parivar Panel",
    location: "Udaipur, Rajasthan",
    category: "Religious",
    type: "Devotional relief panel",
    materials: "Cream sandstone, deep hand relief",
    services: "Concept sketch, clay modelling, deep relief carving, finishing",
    image: ASSETS.shivParivar,
    description: "Shiva, Parvati, Ganesha and Kartikeya in a garden of banana and ashoka — a single-slab family shrine panel.",
    featured: true,
  },
  {
    id: "p1",
    name: "The Tree of Life Residence",
    location: "Udaipur, Rajasthan",
    category: "Residential",
    type: "Double-height feature wall",
    materials: "Makrana marble, hand-carved botanical relief",
    services: "Concept design, carving, backlighting integration, installation",
    image: ASSETS.treeReception,
    description: "A two-storey carved botanical relief that anchors the living room of a private villa.",
    featured: true,
  },
  {
    id: "p11",
    name: "Shiv Aaradhya Mural",
    location: "Udaipur, Rajasthan",
    category: "Religious",
    type: "Monumental devotional mural",
    materials: "Beige sandstone, backlit periphery, chandelier well",
    services: "Mural design, deep relief carving, installation",
    image: ASSETS.shivaMural,
    description: "A towering Shiva relief with trishul and damru, carved for a double-height prayer hall.",
    featured: true,
  },
  {
    id: "p3",
    name: "Shilp House Executive Office",
    location: "Udaipur, Rajasthan",
    category: "Corporate",
    type: "Reception desk & executive wall",
    materials: "Dark emperador marble, fluted wood, brass",
    services: "Reception desk fabrication, brand wall, stone furniture",
    image: ASSETS.office,
    description: "A marble-and-gold corporate reception built around the studio monogram.",
    featured: true,
  },
  {
    id: "p4",
    name: "Hanuman Janmabhoomi Mural",
    location: "Private residence, Jaipur",
    category: "Religious",
    type: "Devotional wall sculpture",
    materials: "Beige sandstone, backlit niche",
    services: "Sculptural relief carving, inscription, installation",
    image: ASSETS.hanuman,
    description: "A monumental backlit Hanuman relief guarding the entrance of a family home.",
    featured: true,
  },
  {
    id: "p5",
    name: "Lakeshore Mural Courtyard",
    location: "Udaipur, Rajasthan",
    category: "Residential",
    type: "Courtyard mural & water feature",
    materials: "Carved stone mural, halo lighting, rock fountain",
    services: "Mural carving, landscape integration, lighting design",
    image: ASSETS.muralLake,
    description: "The Udaipur lakefront carved into a courtyard wall, ringed by a halo of light.",
    featured: true,
  },
  {
    id: "p6",
    name: "The Equestrian Courtyard",
    location: "Residence, Udaipur",
    category: "Hospitality",
    type: "Figurative mural wall",
    materials: "Carved sandstone, floral relief, water feature",
    services: "Concept, figurative carving, planting & water integration",
    image: ASSETS.muralHorse,
    description: "A storytelling mural of horse, rider and lake ghats for a boutique stay.",
    featured: false,
  },
  {
    id: "p7",
    name: "Ganesha Dwar",
    location: "Private residence, Jaipur",
    category: "Religious",
    type: "Black granite line-art panel",
    materials: "Black granite, white marble inlay lines",
    services: "Line-art design, CNC engraving, marble inlay, installation",
    image: ASSETS.ganeshaLine,
    description: "A minimal Ganesha drawn in a single flowing line — white marble inlay on flamed black granite.",
    featured: false,
  },
  {
    id: "p8",
    name: "Jaali Screen Pavilion",
    location: "Udaipur, Rajasthan",
    category: "Architectural",
    type: "Perforated stone screens & arches",
    materials: "Sandstone jaali, carved arches",
    services: "Pattern design, CNC + hand finishing, structural installation",
    image: IMG.jaali,
    description: "Light-filtering sandstone jaalis for a courtyard pavilion.",
    featured: false,
  },
  {
    id: "p9",
    name: "The Stone Gift Atelier",
    location: "Udaipur, Rajasthan",
    category: "Art & Sculpture",
    type: "Collectible gift articles",
    materials: "Marble, granite, semi-precious inlay",
    services: "Design, carving, personalisation, corporate gifting programs",
    image: ASSETS.gifts,
    description: "Handcrafted stone gift articles — from devotional idols to corporate awards.",
    featured: false,
  },
  {
    id: "p19",
    name: "The Veined Muse",
    location: "Udaipur, Rajasthan",
    category: "Art & Sculpture",
    type: "Abstract marble bust",
    materials: "Blue-veined white marble, polished finish",
    services: "Sculpting, contour carving, hand polishing",
    image: ASSETS.marbleBust,
    description: "A contemporary abstract head sculpted from blue-veined marble — art for consoles, lobbies and galleries.",
    featured: false,
  },
  {
    id: "p18",
    name: "White Granite Kitchen & Vanity Suite",
    location: "Udaipur, Rajasthan",
    category: "Residential",
    type: "Kitchen platform, backsplash, vanity top & basin",
    materials: "White granite, honed finish, brass accents",
    services: "Templating, cutting, edge profiling, installation",
    image: ASSETS.kitchenVanitySuite,
    description: "A complete white-granite suite — waterfall kitchen island, full-height backsplash, floating vanity top and carved basin.",
    featured: false,
  },
  {
    id: "p17",
    name: "The Signature Panel Collection",
    location: "Bhilo ka Bedala Plant, Udaipur",
    category: "Architectural",
    type: "Carved panel series — floral, jaali, botanical, 3D geometric, Ganesha",
    materials: "White marble, beige sandstone, grey marble",
    services: "Panel design, CNC carving, hand finishing, custom sizing",
    image: ASSETS.panelLineup,
    description: "Five signature panels straight from the plant floor — jaali lattice, botanical relief, 3D geometry and a baroque Ganesha.",
    featured: false,
  },
  {
    id: "p14",
    name: "Shrinathji Gau Darshan",
    location: "Udaipur, Rajasthan",
    category: "Religious",
    type: "Pichwai-style wall relief",
    materials: "Cream sandstone, Greek-key border frame",
    services: "Pichwai composition, deep relief carving, hand painting",
    image: ASSETS.shrinathjiCows,
    description: "Shrinathji with lotus and twelve adorned cows — a temple-grade Pichwai relief wall.",
    featured: false,
  },
  {
    id: "p15",
    name: "Gajraj Elephant Panel",
    location: "Udaipur, Rajasthan",
    category: "Art & Sculpture",
    type: "Framed relief panel",
    materials: "White marble, chevron caparison detail",
    services: "Relief carving, framing, finishing",
    image: ASSETS.elephantPanel,
    description: "A ceremonial elephant in walking stride, framed in moulded marble.",
    featured: false,
  },
  {
    id: "p16",
    name: "Ashva Horse Panel",
    location: "Udaipur, Rajasthan",
    category: "Art & Sculpture",
    type: "Framed relief panel",
    materials: "White marble, saddle & bridle detail",
    services: "Relief carving, framing, finishing",
    image: ASSETS.horsePanel,
    description: "A Rajputana horse mid-stride — power and grace carved in white marble.",
    featured: false,
  },
  {
    id: "p13",
    name: "XO Stone Panel Collection",
    location: "Udaipur, Rajasthan",
    category: "Architectural",
    type: "Carved wall panels, 12 inch modules",
    materials: "White marble & natural sandstone, CNC + sand blast",
    services: "Panel design, CNC carving, sand blasting, supply",
    image: ASSETS.tileXoMarble,
    description: "Our signature XO wall panels — intricate CNC carving on white marble and lite beige sandstone.",
    featured: false,
  },
  {
    id: "p10",
    name: "Villa Serenity Staircase",
    location: "Ahmedabad, Gujarat",
    category: "Residential",
    type: "Staircase wall & flooring",
    materials: "Italian beige marble, carved wave panel",
    services: "Wall art, stone flooring, step cladding",
    image: "/brochure/crops/flooring-stair.jpg",
    description: "A sculpted wave wall rising alongside a floating marble staircase.",
    featured: false,
  },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Discover", desc: "Understanding the space, requirements and vision." },
  { num: "02", title: "Design", desc: "Developing concepts, motifs, proportions and detailing." },
  { num: "03", title: "Craft", desc: "Carving, shaping, refining and finishing the stone." },
  { num: "04", title: "Install", desc: "Professional installation and final detailing." },
  { num: "05", title: "Experience", desc: "A finished space where stone becomes a defining element." },
];

export const WHY_US = [
  { title: "Bespoke Design", desc: "Made specifically for your project." },
  { title: "Artisan Craftsmanship", desc: "Traditional skill combined with contemporary design." },
  { title: "Natural Materials", desc: "Stone selected for its beauty, character and application." },
  { title: "Project Customization", desc: "From single artworks to complete architectural installations." },
  { title: "Attention to Detail", desc: "Every edge, curve, carving and finish matters." },
  { title: "End-to-End Execution", desc: "From concept development through installation." },
];

export const COLLECTIONS = [
  {
    slug: "story",
    title: "Our Story",
    tagline: "Nature • Design • Legacy",
    image: "/brochure/page-01.jpg",
    desc: "A celebration of India's rich artisanal heritage and contemporary design sensibilities — natural stone transformed into timeless art.",
    points: ["Premium natural stone, ethically sourced", "Generations of carving skill", "Custom designs for every vision", "We deliver across India & globally"],
  },
  {
    slug: "wall-art-decor",
    title: "Wall Art & Home Decor",
    tagline: "Bringing Spaces to Life with Stone",
    image: "/brochure/page-02.jpg",
    desc: "Handcrafted wall art and décor that transforms plain walls into extraordinary statements for living rooms, bedrooms, entrances and pooja rooms.",
    points: ["Double-height murals & 3D panels", "Jaali, geometric & abstract panels", "Pooja room & entrance walls", "Custom sizes for any wall", "Indoor & semi-outdoor spaces"],
  },
  {
    slug: "corporate-gifting",
    title: "Corporate Gift Articles",
    tagline: "Timeless Expressions Carved in Stone",
    image: "/brochure/page-03.jpg",
    desc: "Premium desk clocks, table décor, trophies and mementos in natural stone — corporate gifts that leave lasting impressions.",
    points: ["Desk clocks & table décor", "Trophies & mementos", "Custom engraving & branding", "Festive & corporate gifting programs"],
  },
  {
    slug: "utility",
    title: "Utility & Daily Use Articles",
    tagline: "Functional Elegance in Natural Stone",
    image: "/brochure/page-04.jpg",
    desc: "Serving trays, fruit bowls, organisers, coasters and bathroom sets — everyday essentials carved from natural stone.",
    points: ["Serving trays & fruit bowls", "Desk organisers & coasters", "Bathroom sets", "Easy to clean & maintain"],
  },
  {
    slug: "hotel-resort",
    title: "Hotel & Resort Interior & Exterior",
    tagline: "Crafting Grand Spaces in Natural Stone",
    image: "/brochure/page-05.jpg",
    desc: "Lobbies, guest rooms, restaurants, outdoor landscapes and spas — stone environments designed for hospitality.",
    points: ["Lobby & reception spaces", "Guest rooms & suites", "Restaurants & lounges", "Outdoor landscapes & spa areas", "Custom projects end-to-end"],
  },
  {
    slug: "kitchen",
    title: "Kitchen Platform & Vanity",
    tagline: "Beauty That Works Every Day",
    image: "/brochure/page-06.jpg",
    desc: "Kitchen platforms and vanity tops in granite and marble — heat resistant, durable and easy to maintain.",
    points: ["Kitchen platforms & vanity tops", "Heat & scratch resistant", "Edge profiles: straight, bevel, bullnose, ogee", "Custom sizes for any layout"],
  },
  {
    slug: "office",
    title: "Office Décor",
    tagline: "Elevate Workspaces with Timeless Art",
    image: "/brochure/page-07.jpg",
    desc: "Reception desks, wall panels, murals and table décor that make workspaces feel premium and professional.",
    points: ["Reception desks & counters", "Feature walls & murals", "Table décor & accessories", "Brand-customised designs"],
  },
  {
    slug: "flooring",
    title: "Flooring",
    tagline: "Natural Beauty Under Every Step",
    image: "/brochure/page-08.jpg",
    desc: "Marble, granite, kota, sandstone, travertine and limestone flooring — timeless beauty with lasting durability.",
    points: ["Six natural stone options", "Indoor & outdoor flooring", "Staircases & high-traffic areas", "Custom finishes & inlay patterns"],
  },
  {
    slug: "parking",
    title: "Parking Floor",
    tagline: "Strength Meets Style for Every Entry",
    image: "/brochure/page-09.jpg",
    desc: "Heavy-duty stone parking floors built for vehicles — slip resistant, low maintenance and sophisticated.",
    points: ["Withstands heavy vehicles", "Slip-resistant finishes", "Driveways, ramps & parking areas", "Low maintenance"],
  },
  {
    slug: "front-elevation",
    title: "Front Elevation",
    tagline: "Exterior Stone Décor",
    image: "/brochure/page-10.jpg",
    desc: "Exterior stone décor that transforms building facades — jaali panels, mural walls, boundary décor and window panels.",
    points: ["Exterior jaali & mural panels", "Boundary wall décor", "Window & door panels", "Exterior art panels & stone signage", "Weather-proof natural stone"],
  },
];

export const GALLERY_IMAGES = [
  ASSETS.treeReception,
  ASSETS.shivaMural,
  ASSETS.shrinathjiCows,
  ASSETS.hanuman,
  ASSETS.muralLake,
  ASSETS.muralHorse,
  ASSETS.office,
  ASSETS.confRoom,
  ASSETS.kitchenIsland,
  ASSETS.kitchenVanitySuite,
  ASSETS.panelLineup,
  ASSETS.elephantPanel,
  ASSETS.horsePanel,
  ASSETS.ganeshaLine,
  ASSETS.marbleBust,
  ASSETS.gifts,
  ASSETS.floorBoard,
  ASSETS.floorBoard2,
  ASSETS.tileXoWhite,
  ASSETS.tileXoMarble,
  ASSETS.tileXoSand,
  ASSETS.tileFanMarble,
  ASSETS.tileFanWhite,
  ASSETS.tileMonstera,
  ASSETS.headSculpture,
  ASSETS.krishnaRelief,
  ASSETS.artisanBlue,
  ASSETS.artisanGreen,
  ASSETS.artisanPainting,
  ASSETS.cncMachine,
  ASSETS.bridgeSaw,
  ASSETS.clientVisit,
  ASSETS.clientVisit2,
  ASSETS.banner,
  ASSETS.wallart,
];

export const MARQUEE_ITEMS = [
  "Corporate Gifting",
  "Exterior Jaali",
  "Marble Murals",
  "Architectural Art",
  "Udaipur Heritage",
  "Stone Furniture",
  "Natural Stone Carving",
  "Feature Walls",
];
